<script lang="ts">import { icon, iconActive, iconHover } from "./colors";
export let size = 17;
export let active = false;
export let hover = false;
export let color = undefined;
let width = size;
let height = size;
let fill = color ? color : active ? iconActive : hover ? iconHover : icon;
$: fill = color ? color : active ? iconActive : hover ? iconHover : icon;
</script>

<svg {width} {height} viewBox="0 0 24 30" {fill} xmlns="http://www.w3.org/2000/svg">
	<path
		d="M15.2364 21.6958C14.6172 22.1464 14.0265 22.1768 13.6736 22.1375C12.7752 22.0371 11.9691 21.3598 11.5174 20.3258C11.2143 19.632 11.0531 18.7002 11.235 17.7168C9.80736 18.481 7.97559 20.2162 7.97559 24.0896C7.97559 26.3091 9.78129 28.1148 12.0008 28.1148C14.2203 28.1148 16.026 26.3091 16.026 24.0896C16.0261 23.2224 15.7446 22.3835 15.2364 21.6958Z"
		{fill}
	/>
	<path
		d="M23.9806 17.159L23.851 14.8473L22.4398 16.6828C22.3274 16.8289 22.0881 17.0873 21.7828 17.323C21.9035 16.9231 22.0112 16.4671 22.0824 15.9642C22.3289 14.2223 22.1754 11.549 20.0451 8.70461L19.1512 7.51112L18.5655 8.88234C17.8899 10.4641 16.7967 11.2576 15.7807 10.9039C14.9986 10.6318 14.3629 9.73664 14.0367 8.44786C13.7324 7.24583 13.5556 5.13055 14.4415 1.87959L14.8172 0.5L13.4223 0.814215C8.71713 1.8742 5.5465 5.21558 4.25314 10.4771C3.70945 12.6889 3.60706 14.7843 3.6223 16.2015C2.51051 15.3027 1.95537 14.5141 1.94087 14.4932L0.881854 12.9374L0.399473 14.7591C0.134361 15.7604 0 16.7962 0 17.8378C0 24.4051 5.30316 29.7562 11.8519 29.8359C8.75191 29.7571 6.25434 27.2108 6.25434 24.0921C6.25434 20.0717 7.98149 17.9297 9.43041 16.8408C11.0114 15.6526 12.6058 15.4414 12.6729 15.433L14.6628 15.1837L13.472 16.7974C12.7215 17.8142 12.7843 18.9324 13.0933 19.6397C13.3168 20.1513 13.6414 20.4054 13.8639 20.4303C14.1445 20.4622 14.4267 20.1402 14.5699 19.9458L15.1319 19.1823L15.8374 19.8156C17.0501 20.9045 17.7457 22.4633 17.7457 24.0921C17.7457 27.2108 15.2481 29.7571 12.1481 29.8359C18.6968 29.7562 24 24.4051 24 17.8378C24.0001 17.6181 23.9935 17.3896 23.9806 17.159Z"
		{fill}
	/>
</svg>

<style>
	.icon {
    margin: 0px
}
</style>
